import { useQuery } from "@tanstack/react-query";
import { alphartisApiAxios } from "@/config/axios";

export const HEALTH_CHECK_RESOURCE = "health" as const;
export const HEALTH_CHECK_API_PATH = `/${HEALTH_CHECK_RESOURCE}` as const;

export function useHealthCheckQuery(options?: Omit<Parameters<typeof useQuery>[0], "queryKey" | "queryFn">) {
  return useQuery({
    queryKey: [HEALTH_CHECK_RESOURCE],
    queryFn: async () => {
      try {
        const res = await alphartisApiAxios.get(HEALTH_CHECK_API_PATH);
        return res.status === 204;
      } catch {
        return false;
      }
    },
    ...options,
  });
}
